var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5,0.7c-2.6,0-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8s4.8-2.1,4.8-4.8S8.1,0.7,5.5,0.7z M5.5,9.3c-2,0-3.8-1.7-3.8-3.8\r\n\ts1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8S7.5,9.3,5.5,9.3z"}));
}

Circle.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 11 11","style":{"enableBackground":"new 0 0 11 11"},"xmlSpace":"preserve"};

module.exports = Circle;

Circle.default = Circle;
